import { apiClient } from "./client";

export interface DocumentoPrivacy {
  id: string;
  titolo: string | null;
  descrizione: string | null;
  file_url: string | null;
  versione: string | null;
  data_pubblicazione: string | null;
  pubblicato: boolean;
  created_at: string;
}

export async function listDocuments(): Promise<{ documenti: DocumentoPrivacy[] }> {
  const { data } = await apiClient.get<{ documenti: DocumentoPrivacy[] }>("/documenti-privacy");
  return data;
}

export interface UploadDocumentPayload {
  file: File;
  titolo?: string;
  descrizione?: string;
  versione?: string;
  data_pubblicazione?: string;
  pubblicato?: boolean;
}

export async function uploadDocument(payload: UploadDocumentPayload): Promise<{ documento: DocumentoPrivacy }> {
  const formData = new FormData();
  formData.append("file", payload.file);
  if (payload.titolo) formData.append("titolo", payload.titolo);
  if (payload.descrizione) formData.append("descrizione", payload.descrizione);
  if (payload.versione) formData.append("versione", payload.versione);
  if (payload.data_pubblicazione) formData.append("data_pubblicazione", payload.data_pubblicazione);
  if (payload.pubblicato !== undefined) formData.append("pubblicato", String(payload.pubblicato));

  const { data } = await apiClient.post<{ documento: DocumentoPrivacy }>("/documenti-privacy", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function updateDocument(
  id: string,
  payload: Partial<Pick<DocumentoPrivacy, "titolo" | "descrizione" | "versione" | "data_pubblicazione" | "pubblicato">>
): Promise<{ documento: DocumentoPrivacy }> {
  const { data } = await apiClient.patch<{ documento: DocumentoPrivacy }>(`/documenti-privacy/${id}`, payload);
  return data;
}

export async function deleteDocument(id: string): Promise<{ success: true }> {
  const { data } = await apiClient.delete<{ success: true }>(`/documenti-privacy/${id}`);
  return data;
}
